export default "__VITE_ASSET__af75d716__"